import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_Form12 = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='HFI_Form12' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h3>Financial Policy</h3></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Person Served</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Record #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPersonServed' name='txtPersonServed' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtRecord' name='txtRecord' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>The staff at Heritage Foundation, Inc. (hereafter referred to as HFI) are committed to providing caring and professional mental health care to all of our person served. As part of the delivery of mental health services, we have established a financial policy that provides payment policies and options to all consumers.
                    The financial policy of HFI is designed to clarify the payment policies as determined by the management of HFI. <br /><br />

                    The Person Responsible for Payment of Account is required to sign the form Payment Contract for Services, which explains the fees and collection policies of HFI. Your insurance policy, if any, is a contract between you and the insurance company;
                    we are not part of the contract with you and your insurance company. <br /><br />

                    As a service to you, HFI will bill insurance companies and other third-party payers but cannot guarantee such benefits or the amounts covered and is not responsible for the collection of such payments.
                    In some cases insurance companies or other third-party payers may consider certain services as not reasonable or necessary or may determine that services are not covered. In such cases the Person Responsible for Payment of Account is responsible for payment of these services. We charge our person served the usual and customary rates for the area. Person served are responsible for
                    payments regardless of any insurance company's arbitrary determination of usual and customary rates. <br /><br />

                    The Person Responsible for Payment (as noted in the Payment Contract for Services) will be financially responsible for payment of such services. The Person Responsible for Payment of Account is financially responsible for paying funds not paid by insurance companies or third-party payers after 60 days. Payments not received after 120 days are subject to collections.
                    A 1% per month interest rate is charged for accounts over 60 days.</p>

                <p className='w-750'><b><h4>Insurance deductibles and co-payments are due at the time of service.</h4></b>
                    <br />
                    All insurance benefits will be assigned to HFI (by insurance company or third-party provider) unless the Person Responsible for Payment of Account pays the entire balance each session. <br /><br />

                    Person served are responsible for payments at the time of services. The adult accompanying a minor (or guardian of the minor) is responsible for payments for the child at the time of service. Unaccompanied minors will be denied nonemergency service unless charges have been preauthorized to an approved credit plan,
                    or payment at the time of service. <br /><br />

                    Missed appointments or cancellations less than 24 hours prior to the appointment are charged at a rate noted in the Payment Contract for Services. <br />
                    Payment methods include Cashier's Check or Money Order. <br /><br />

                    Questions regarding the financial policies can be answered by the Office Manager; Comptroller; Program Manager; Outpatient Coordinator. <br /><br />
                    I (we) have read, understand, and agree with the provisions of the Financial Policy.</p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Person responsible for account:</td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Co-responsible party:</td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}  
